/** 
 * The CMSBlock component
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Col, Row, Button } from 'reactstrap';
/**
 * CMSBlock component
 * - renders cms content set in the admin panel
 */
const ContentBlockFullWidth = (props, context) => {
  const {cmsblock, noImage, hasInfoButton, toggleModal, hideTitle} = props;
  const HeadingTag = 'h' + (props.headinglevel ? props.headinglevel : '2');
  return (
    <Container className="cmsblock">
      <Row>
        <Col xs={12}>
          { cmsblock.title && !hideTitle &&
            <HeadingTag>
              {cmsblock.title}
              { hasInfoButton && 
                <Button color="link" onClick={toggleModal} className="btn checklists__hero__help">
                <i className="fa fa-info-circle" aria-hidden="true" />
                <span className='sr-only'>{context.t("Das ist ein Hilfstext, wie die Listen genutzt werden können. Dieser Text kann durch den Infobutton auf der Seite 'Fahrplan' wieder geöffnet werden.")}</span>
              </Button>
              }
            </HeadingTag>
          }
          <div dangerouslySetInnerHTML={{__html: cmsblock.text}} />
        </Col>
        {!noImage && cmsblock.image &&
          <Col xs={12}>
            <img src={cmsblock.image} alt={cmsblock.image_description} className="cmsblock__image"/>
          </Col>
        }
      </Row>
    </Container>
  );
}

/** define proptypes for the form */
ContentBlockFullWidth.propTypes = {
  cmsblock: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
ContentBlockFullWidth.contextTypes = {
  t: PropTypes.func
}
export default ContentBlockFullWidth;